import { createSelector } from '@reduxjs/toolkit';
import { selectLivingConditionsValue } from './selectLivingConditionsValue';
import { EFacilityType } from '../../../../packages/JsonQuery';

const OPTIONS = [
  { label: 'Неважно', value: null },
  { label: 'Можно с детьми', value: EFacilityType.KidsAllowed },
  { label: 'Можно с животными', value: EFacilityType.PetsAllowed },
];

export const selectLivingConditionsFilter = createSelector(selectLivingConditionsValue, value => ({
  label: 'Условия проживания',
  value,
  options: OPTIONS,
}));
